module.exports = __webpack_public_path__ + "assets/mp3/audio9/lesson_2_05_audio1.mp3";